import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";
// eslint-disable-next-line
import { actions } from "react-redux-form";

//Auth
import { auth, db } from "./../../firebase";

function* handleBail(action) {
  if (action.type === ACTIONS.BAIL) {
    yield auth.doLogout();
    yield db.doRemoveListeners();
    yield put({
      type: ACTIONS.OPEN_SNACKBAR,
      payload: {
        variant: "error",
        message: `access error: ${action.err}`
      }
    });
  }
}

export function* bailSaga() {
  yield takeEvery(ACTIONS.BAIL, handleBail);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/bail.js